export default "__VITE_ASSET__DT13NwLL__"